import React, { useCallback, useState } from "react";
import { Lock, ShieldCheck } from "lucide-react";
import "./AccessGate.css";

interface AccessGateProps {
  onUnlock: () => void;
}

const ACCESS_PASSCODE = "2star";

const AccessGate: React.FC<AccessGateProps> = ({ onUnlock }) => {
  const [passcode, setPasscode] = useState("");
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault();
      if (passcode.trim() === ACCESS_PASSCODE) {
        sessionStorage.setItem("myrep_predeploy_unlocked", "true");
        onUnlock();
      } else {
        setError("Incorrect passcode.");
      }
    },
    [passcode, onUnlock],
  );

  return (
    <div className="access-gate">
      <div className="access-gate__card">
        <div className="access-gate__icon">
          <Lock size={22} />
        </div>
        <p className="access-gate__title">MyRep Pre-Deploy Checklist</p>
        <p className="access-gate__subtitle">
          This page is only accessible to authorized team members. Enter the
          passcode to continue.
        </p>

        <form className="access-gate__form" onSubmit={handleSubmit}>
          <label className="access-gate__label" htmlFor="access-gate-passcode">
            <ShieldCheck size={15} />
            Passcode
          </label>
          <input
            id="access-gate-passcode"
            className="access-gate__input"
            type="password"
            placeholder="Enter passcode"
            value={passcode}
            onChange={(e) => {
              setPasscode(e.target.value);
              setError(null);
            }}
            required
            autoFocus
          />
          {error && <p className="access-gate__error">{error}</p>}
          <button
            className="access-gate__submit"
            type="submit"
            disabled={!passcode.trim()}
          >
            Unlock checklist
          </button>
        </form>
      </div>
    </div>
  );
};

export default AccessGate;
